export default __webpack_public_path__ + "images/fi_edit-3.svg";